import { render, staticRenderFns } from "./UserSelect.vue?vue&type=template&id=7663bc63&scoped=true&"
import script from "./UserSelect.vue?vue&type=script&setup=true&lang=js&"
export * from "./UserSelect.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7663bc63",
  null
  
)

export default component.exports